import Button from 'components/Button';
import Error from 'components/form/Error';
import PlusIcon from 'components/icons/Plus';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC, useState } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import MentorshipReferee from 'types/MentorshipReferee';
import Create from './Create';
import Referee from './Referee';

const Grid = styled.div`
  max-width: 60rem;
  width: 100%;
  align-self: center;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 1rem;
  column-gap: 1.5rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: center;
  border: 1px solid var(--gray-300);
  padding: 1rem;
  height: 3.5rem;
  border-radius: 0.5rem;
`;

const CreateCell = styled(Cell)`
  padding: 0;
  border: none;
  justify-content: space-between;
  button {
    width: 100%;
    height: 100%;
    svg {
      margin: 0;
    }
  }
`;

const Referees: FC = () => {
  const [createOpen, setCreateOpen] = useState<boolean>(false);
  const { data, error } = useSWR<MentorshipReferee[]>('/mentorship-referee');
  return (
    <>
      <PageHeadContainer>
        <PageTitle>
          <h1>Chargés de mentorat</h1>
        </PageTitle>
      </PageHeadContainer>
      {error ? (
        <Error>Une erreur est survenue.</Error>
      ) : data ? (
        <Grid>
          {data?.map((referee, idx) => (
            <Referee referee={referee} key={idx} />
          ))}
          <CreateCell>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => setCreateOpen(true)}
            >
              <PlusIcon />
            </Button>
          </CreateCell>
        </Grid>
      ) : (
        <LoaderContainer>
          <DefaultLoader />
        </LoaderContainer>
      )}
      <Create open={createOpen} close={() => setCreateOpen(false)} />
    </>
  );
};

export default Referees;
